import { UIEvent, ReactElement, cloneElement, useEffect, useRef, useState } from 'react';
import { Container, GradientOverlay } from './ScrollGradient.styled';

interface ScrollGradientProps {
  children: ReactElement;
}

const ScrollGradient = (props: ScrollGradientProps) => {
  const { children } = props;
  const [showGradient, setShowGradient] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleScroll = (e: UIEvent<HTMLDivElement>) => {
    const element = e.currentTarget;
    const isAtEnd = Math.abs(element.scrollWidth - element.clientWidth - element.scrollLeft) < 1;

    setShowGradient(!isAtEnd);
  };

  useEffect(() => {
    if (contentRef.current) {
      setShowGradient(contentRef.current.scrollWidth > contentRef.current.clientWidth);
    }
  }, []);

  const childWithProps = cloneElement(children, {
    ref: contentRef,
    onScroll: handleScroll,
  });

  return (
    <Container>
      {childWithProps}
      <GradientOverlay $show={showGradient} className="gradient-overlay" />
    </Container>
  );
};
export default ScrollGradient;
